export const getLink = (docType: string, id: string | number): string => {
    switch (docType.toLocaleLowerCase()) {
        case "urs":
            return `/urs/edit/${id}`;
        default:
            return `/document/edit/${id}`;
    }
};

export const getServerProcessRelatedDocumentLink = (relatedObjectType: string, id: string | number): string | null => {
    switch (relatedObjectType) {
        case "URS":
            return `/urs/edit/${id}`;
        case "IMPORTED_DOCUMENT":
            return `/imported-documents/edit/${id}`;
        case "SUPPLIER_IMPORTED_URS":
            return `/supplier-imported-urs/edit/${id}`;
        case "DOCUMENT":
            return `/document/edit/${id}`;
        default:
            return null;
    }
};